// Event categories — same keys as the backend (event_types.py)
export const EVENT_TYPES = [
  { key: "concert", label: "Concert", plural: "Concerts" },
  { key: "club", label: "Soirée club / DJ set", plural: "Soirées club" },
  { key: "festival", label: "Festival", plural: "Festivals" },
  { key: "danse", label: "Danse / Battle", plural: "Danse & battles" },
  { key: "spectacle", label: "Spectacle", plural: "Spectacles" },
  { key: "conference", label: "Conférence", plural: "Conférences" },
];

export const EVENT_TYPE_LABEL = Object.fromEntries(EVENT_TYPES.map((t) => [t.key, t.label]));
export const EVENT_TYPE_PLURAL = Object.fromEntries(EVENT_TYPES.map((t) => [t.key, t.plural]));
export const isEventType = (k) => k in EVENT_TYPE_LABEL;
